<script setup lang="ts">
  import { computed, ref } from 'vue';
  import { useRoute } from 'vue-router';
  import { RouterView } from 'vue-router';
  import Header from './components/Header.vue';
  import Alerts from './components/Alerts.vue';
  import Footer from './components/Footer.vue';
  import { useUserStore, useAlertStore } from '@/stores';

  const loading = ref(true);
  const route = useRoute();

  const mainLandmarkLabel = computed(() => {
    const routeTitle = route.meta?.title;

    if (typeof routeTitle === 'string' && routeTitle.trim()) {
      return routeTitle;
    }

    return 'Main content';
  });

  const init = async () => {
    const userStore = useUserStore();
    const alertStore = useAlertStore();

    Promise.all([
      userStore.initStudent(),
      userStore.initShoppingCart(),
      userStore.initCapsimChallenge(),
      alertStore.initAlerts(),
    ]).then((values) => {
      loading.value = false;
    });
  };
  init();
</script>

<template>
  <div class="h-screen dark:bg-gradient-to-br dark:from-gray-900 dark:to-gray-700 flex flex-col">
    <a href="#main" class="skip-link">Skip to main content</a>
    <Header />

    <main
      role="main"
      id="main"
      tabindex="-1"
      :aria-label="mainLandmarkLabel"
      :aria-busy="loading ? 'true' : 'false'"
      class="container mx-auto px-5 md:px-10 flex-grow"
    >
      <Alerts />
      <Loader v-if="loading" class="mt-10 mb-10 m-auto" />
      <RouterView v-if="!loading" />
    </main>
    <Footer class="" />
  </div>
</template>
